module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS013B7DH03-10-7-17.c7d4b8a6.pdf";